const { trackEvent } = require('./facebook');

window.stripeButton = (params) => {
    return {
        submitting: false,
        error: null,
        submit() {
            this.error = null;

            if (!this.$refs.tc_checkbox.checkValidity()) {
                this.$refs.form.reportValidity();
                return;
            }

            this.submitting = true;

            grecaptcha.ready(() => {
                grecaptcha
                    .execute(process.env.MIX_RECAPTCHA_SITE_KEY, {
                        action: 'subscribe',
                    })
                    .then((token) => {
                        fetch('/stripe/session', {
                            method: 'POST',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'X-CSRF-Token': params.csrf_token,
                            },
                            body: JSON.stringify({
                                token,
                                price_id: params.price_id,
                                type: params.type,
                                success_url: `${
                                    params.success_url || 'payment/success'
                                }?stripe_session_id={CHECKOUT_SESSION_ID}`,
                                cancel_url: params.cancel_url,
                                promo_code: params.promo_code,
                                attrib: params.attrib,
                            }),
                        })
                            .then(async (res) => {
                                if (!res.ok) {
                                    const json = await res.json();
                                    throw new Error(json.message);
                                }

                                return res.json();
                            })
                            .then((res) => {
                                trackEvent('InitiateCheckout', {
                                    content_ids: params.price_id,
                                });

                                return stripe.redirectToCheckout({
                                    sessionId: res.session_id,
                                });
                            })
                            .catch((e) => {
                                this.submitting = false;
                                this.error = e.message;
                            });
                    });
            });
        },
    };
};
